
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34053',
  depVersions: {
  "documents-public-ui": "static-1.34053",
  "client-types": "static-1.450",
  "documents-lib": "static-1.34058",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1957",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5424",
  "hs-test-utils": "static-1.7837",
  "hub-http": "static-1.6050",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11271",
  "I18n": "static-7.1580",
  "jasmine-immutable": "static-1.2848",
  "jasmine-runner": "static-1.6302",
  "lodash": "static-1.3",
  "quartz": "static-1.6774",
  "react": "static-7.180",
  "react-dlb": "static-1.73",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16482",
  "reporting-data": "static-1.66656",
  "reporting-testing-lib": "static-1.8589",
  "reporting-visualizations": "static-1.58732",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4597",
  "webpack-env": "static-1.54",
  "atom": "static-1.4901",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2320",
  "classnames": "static-2.10",
  "cssUtils": "static-1.744",
  "customer-data-filters-ui": "static-1.39018",
  "customer-data-objects": "static-1.7479",
  "customer-data-property-utils": "static-1.7910",
  "data-fetching-client": "static-1.9508",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4362",
  "flux-actions": "static-1.311",
  "FormsCommonComponents": "static-1.85367",
  "FormUrlGenerator": "static-2.4557",
  "foundations-components": "static-1.7583",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11579",
  "icons": "static-2.625",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6990",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3686",
  "property-translator": "static-1.5240",
  "quartz-config": "static-1.552",
  "quartz-core": "static-1.5993",
  "quick-fetch": "static-1.3767",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5204",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7993",
  "reference-resolvers-lite": "static-1.7923",
  "report-customization-components": "static-1.12607",
  "reporting-enablement": "static-1.22185",
  "reporting-reports": "static-1.66334",
  "reporting-snowflake": "static-1.55274",
  "reporting-ui-components": "static-2.63927",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4466",
  "sales-content-partitioning": "static-1.8766",
  "SalesContentIndexUI": "static-3.8945",
  "sanitize": "static-1.4305",
  "sanitize-text": "static-1.7976",
  "self-service-api": "static-1.10069",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1581",
  "signup-constants": "static-1.18486",
  "signup-ui-lego-core": "static-1.20496",
  "signup-ui-url-generator": "static-2.7865",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4602",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10825",
  "ui-addon-i18n": "static-1.10975",
  "ui-addon-react-router-dom": "static-1.9376",
  "ui-addon-upgrades": "static-9.17700",
  "ui-asset-management-lib": "static-1.10748",
  "ui-images": "static-2.1105",
  "UIComponents": "static-3.8218",
  "usage-tracker": "static-1.7166",
  "usage-tracker-container": "static-1.7156",
  "usage-tracker-core": "static-1.7016",
  "usage-tracker-public": "static-1.6977",
  "viral-links-lib": "static-1.6868",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3258",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3051",
  "quartz-webpack": "static-1.2998",
  "ai-components-ui-library": "static-1.8437",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4668",
  "foundations-theming": "static-1.4241",
  "quartz-auth": "static-1.449",
  "ui-business-units-lib": "static-1.8860",
  "usage-tracker-session-replay": "static-1.4852",
  "foundations-theming-base": "static-1.3226",
  "HeadJS": "static-2.718",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2948",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4157",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7755",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3450",
  "persist-promise": "static-1.3539",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.608",
  "hs-story-utils": "static-1.9257",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9551",
  "hubspotter-http": "static-1.4508",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7079",
  "crm-message-bus": "static-1.42463",
  "customer-data-filters-ui-msw-helpers": "static-1.21453",
  "customer-data-objects-ui-components": "static-1.12841",
  "customer-data-reference-ui-components": "static-1.12977",
  "customer-data-ui-utilities": "static-1.9654",
  "framework-builder-read-service-client": "static-1.3863",
  "framework-data-schema-quick-fetch": "static-1.6608",
  "framework-data-schema-resolvers": "static-1.6703",
  "inbound-db-properties-service-client": "static-1.3704",
  "multi-account-reference-resolvers": "static-1.804",
  "onboarding-tours": "static-1.16306",
  "reporting-datasets-permissions-lib": "static-1.13156",
  "ui-addon-teams": "static-1.21281",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67714",
  "customer-data-properties": "static-1.50862",
  "forms-ai-lib": "static-1.4055",
  "forms-utils-lib": "static-1.12225",
  "foundations-components-test-utils": "static-1.5066",
  "react-dnd-compat": "static-1.4451",
  "react-tinymce": "static-1.54710",
  "tinymce-config": "static-2.53836",
  "ui-gdpr-components": "static-1.10178",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3852",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1302",
  "ui-fonts": "static-1.533",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.803",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.439",
  "quartz-i18n": "static-1.449",
  "quartz-routing": "static-1.204",
  "quartz-test": "static-1.449",
  "quartz-tracking": "static-1.153",
  "batch-promise": "static-1.1382",
  "external-options-client-types": "static-1.4014",
  "react-colorpicker": "static-2.10042",
  "copilot-toolkit": "static-1.10615",
  "data-quality-ui-library": "static-1.12397",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6294",
  "reporting-action-components": "static-1.40736",
  "reporting-insights-lib": "static-1.1217",
  "reporting-plugins": "static-1.10022",
  "ui-addon-draggable-compat": "static-2.4085",
  "ui-addon-opt": "static-4.8216",
  "ui-shepherd-react": "static-3.9977",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24822",
  "hubspot-apollo-client": "static-1.4711",
  "sales-templates-service-types-lib": "static-1.4022",
  "merchandise-lib": "static-1.260",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5521",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3935",
  "timezone-utils": "static-2.5075",
  "bender-build-tools": "static-1.2970",
  "chatspot-core": "static-1.20467",
  "chirp-fetch": "static-1.1713",
  "bend-plugin-foundations-theming": "static-1.2724",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9549",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3653",
  "crm-pipelines-api-client-types": "static-1.3995",
  "multi-currency-client-types": "static-1.3546",
  "getting-started-shared-tasks": "static-1.17976",
  "growth-data-modal": "static-1.5189",
  "growth-onboarding-confetti": "static-1.2903",
  "growth-onboarding-next-action-utils": "static-1.1380",
  "navigation-components": "static-1.17379",
  "onboarding-tours-client": "static-1.4520",
  "onboarding-tours-utils": "static-1.372",
  "ui-shepherd-tracker": "static-1.7358",
  "ui-universal-auth": "static-1.8744",
  "user-context": "static-1.4930",
  "cms-field-types": "static-1.4638",
  "content-icons-ui": "static-1.2167",
  "integrations-lib": "static-1.15531",
  "calling-global-api": "static-1.63791",
  "calling-internal-common": "static-1.31126",
  "calling-lifecycle-internal": "static-1.65173",
  "calling-lifecycle-messages": "static-1.57467",
  "commerce-products-lib": "static-1.8946",
  "crm-links": "static-1.6097",
  "file-manager-components": "static-1.22992",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.511",
  "inbounddb-objects-service-types": "static-1.4078",
  "meetings-icalendar-utils-lib": "static-1.463",
  "object-builder-ui-client": "static-1.48108",
  "pipeline-validation-client-types": "static-1.3819",
  "property-value-citations": "static-1.1476",
  "pulse": "static-1.347",
  "smart-property-lib": "static-1.6058",
  "tiered-pricing": "static-1.873",
  "ui-addon-iframeable": "static-1.8877",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19525",
  "tinymce-themes": "static-1.55806",
  "data-token-picker": "static-1.16098",
  "hub-http-contrib": "static-1.2874",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39921",
  "tinymce-plugins": "static-1.56950",
  "ui-addon-sales-email": "static-1.5045",
  "magpie-lib": "static-1.5425",
  "magpie-types": "static-1.4885",
  "simple-logging-lib": "static-1.2881",
  "content-assistance-lib": "static-1.7494",
  "dashboard-lib": "static-1.80758",
  "ExportDialog": "static-6.10218",
  "hubspot-prosemirror": "static-1.17693",
  "hubspot-prosemirror-plugins": "static-1.17685",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8524",
  "campaign-roi-lib": "static-1.8381",
  "feedback-loader": "static-1.28926",
  "apollo-link-hub-http": "static-2.4482",
  "hubspot-apollo-cache": "static-1.170",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2188",
  "purchase-motions-api": "static-1.5524",
  "trials-service-types": "static-1.3730",
  "growth-onboarding-next-action-components": "static-1.1408",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.556",
  "unified-auth-core-lib": "static-1.539",
  "getting-started-shared-tasks-store": "static-1.17094",
  "integrations-error-boundary-lib": "static-1.12946",
  "integrations-tracking-lib": "static-1.5419",
  "native-integrations-shared-strings": "static-1.7619",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10204",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31132",
  "shared-worker-versioning": "static-1.10870",
  "calling-usage-tracker": "static-1.6372",
  "voice-sms-access-library": "static-1.341",
  "customer-data-tracking": "static-1.6713",
  "commerce-permissions": "static-1.590",
  "products-iframe-lib": "static-1.7417",
  "products-ui-components-shared-msw-handlers": "static-1.9933",
  "location-customization-utils-lib": "static-1.8665",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3985",
  "video-components-external": "static-1.10668",
  "video-data-lib": "static-1.34326",
  "directed-graph": "static-1.770",
  "event-emitter": "static-1.778",
  "breeze-intelligence-kit": "static-1.5368",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9634",
  "fsm": "static-1.3562",
  "policy-lib": "static-1.6607",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9697",
  "navigation-messaging": "static-1.6706",
  "FileManagerLib": "static-1.38632",
  "NamespacedHubStyle": "static-2.8926",
  "FileManagerCore": "static-1.38491",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12095",
  "layout-dnd-utils": "static-1.11070",
  "react-codemirror": "static-1.10457",
  "ui-addon-emoji-picker": "static-1.9718",
  "ui-brand-identity-lib": "static-1.14092",
  "ui-addon-video-player": "static-1.8527",
  "ui-coaching-tips": "static-1.28032",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8398",
  "payment-link-components": "static-1.23028",
  "EmailSignatureEditor": "static-1.23979",
  "eligibility-engine-service-types": "static-1.3011",
  "universal-page-editor-lib": "static-1.2830",
  "calling-orchestration-schema": "static-1.35118",
  "sales-views-client-types": "static-1.4117",
  "crm-record-cards-service-types": "static-1.3473",
  "content-media-composition-data-lib": "static-1.11570",
  "content-media-compositions": "static-2.15577",
  "media-bridge-lib": "static-1.18620",
  "trellis-story-utils": "static-1.4351",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5658",
  "FileManagerImages": "static-1.36143",
  "video-components": "static-1.12671",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4362",
  "video-embed": "static-1.35160",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67789",
  "layout-data-lib": "static-1.9395",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6413",
  "commerce-tours-lib": "static-1.5763",
  "growth-onboarding-reliability": "static-1.4917",
  "sales-checkout-service-client": "static-1.3498",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21361",
  "sales-email-signature-service-client": "static-1.3674",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21453",
  "outpost": "static-1.4033",
  "advanced-menus-core": "static-1.14863",
  "advanced-menus-lib": "static-1.11834",
  "ui-memberships-settings-lib": "static-1.33539",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14862",
  "simple-menus-lib": "static-1.16379"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34053",
  "client-types": "/client-types/static-1.450",
  "documents-lib": "/documents-lib/static-1.34058",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1957",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5424",
  "hs-test-utils": "/hs-test-utils/static-1.7837",
  "hub-http": "/hub-http/static-1.6050",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11271",
  "I18n": "/I18n/static-7.1580",
  "jasmine-immutable": "/jasmine-immutable/static-1.2848",
  "jasmine-runner": "/jasmine-runner/static-1.6302",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6774",
  "react": "/react/static-7.180",
  "react-dlb": "/react-dlb/static-1.73",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16482",
  "reporting-data": "/reporting-data/static-1.66656",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8589",
  "reporting-visualizations": "/reporting-visualizations/static-1.58732",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4597",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4901",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2320",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.744",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39018",
  "customer-data-objects": "/customer-data-objects/static-1.7479",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7910",
  "data-fetching-client": "/data-fetching-client/static-1.9508",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4362",
  "flux-actions": "/flux-actions/static-1.311",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85367",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4557",
  "foundations-components": "/foundations-components/static-1.7583",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11579",
  "icons": "/icons/static-2.625",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6990",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3686",
  "property-translator": "/property-translator/static-1.5240",
  "quartz-config": "/quartz-config/static-1.552",
  "quartz-core": "/quartz-core/static-1.5993",
  "quick-fetch": "/quick-fetch/static-1.3767",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5204",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7993",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "report-customization-components": "/report-customization-components/static-1.12607",
  "reporting-enablement": "/reporting-enablement/static-1.22185",
  "reporting-reports": "/reporting-reports/static-1.66334",
  "reporting-snowflake": "/reporting-snowflake/static-1.55274",
  "reporting-ui-components": "/reporting-ui-components/static-2.63927",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4466",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8766",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8945",
  "sanitize": "/sanitize/static-1.4305",
  "sanitize-text": "/sanitize-text/static-1.7976",
  "self-service-api": "/self-service-api/static-1.10069",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1581",
  "signup-constants": "/signup-constants/static-1.18486",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20496",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7865",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4602",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10825",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10975",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9376",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17700",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10748",
  "ui-images": "/ui-images/static-2.1105",
  "UIComponents": "/UIComponents/static-3.8218",
  "usage-tracker": "/usage-tracker/static-1.7166",
  "usage-tracker-container": "/usage-tracker-container/static-1.7156",
  "usage-tracker-core": "/usage-tracker-core/static-1.7016",
  "usage-tracker-public": "/usage-tracker-public/static-1.6977",
  "viral-links-lib": "/viral-links-lib/static-1.6868",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3258",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3051",
  "quartz-webpack": "/quartz-webpack/static-1.2998",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8437",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4668",
  "foundations-theming": "/foundations-theming/static-1.4241",
  "quartz-auth": "/quartz-auth/static-1.449",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8860",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4852",
  "foundations-theming-base": "/foundations-theming-base/static-1.3226",
  "HeadJS": "/HeadJS/static-2.718",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2948",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4157",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7755",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3450",
  "persist-promise": "/persist-promise/static-1.3539",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.608",
  "hs-story-utils": "/hs-story-utils/static-1.9257",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9551",
  "hubspotter-http": "/hubspotter-http/static-1.4508",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7079",
  "crm-message-bus": "/crm-message-bus/static-1.42463",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21453",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12841",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12977",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9654",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3863",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6608",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6703",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3704",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.804",
  "onboarding-tours": "/onboarding-tours/static-1.16306",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13156",
  "ui-addon-teams": "/ui-addon-teams/static-1.21281",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67714",
  "customer-data-properties": "/customer-data-properties/static-1.50862",
  "forms-ai-lib": "/forms-ai-lib/static-1.4055",
  "forms-utils-lib": "/forms-utils-lib/static-1.12225",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5066",
  "react-dnd-compat": "/react-dnd-compat/static-1.4451",
  "react-tinymce": "/react-tinymce/static-1.54710",
  "tinymce-config": "/tinymce-config/static-2.53836",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10178",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3852",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1302",
  "ui-fonts": "/ui-fonts/static-1.533",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.439",
  "quartz-i18n": "/quartz-i18n/static-1.449",
  "quartz-routing": "/quartz-routing/static-1.204",
  "quartz-test": "/quartz-test/static-1.449",
  "quartz-tracking": "/quartz-tracking/static-1.153",
  "batch-promise": "/batch-promise/static-1.1382",
  "external-options-client-types": "/external-options-client-types/static-1.4014",
  "react-colorpicker": "/react-colorpicker/static-2.10042",
  "copilot-toolkit": "/copilot-toolkit/static-1.10615",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12397",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6294",
  "reporting-action-components": "/reporting-action-components/static-1.40736",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1217",
  "reporting-plugins": "/reporting-plugins/static-1.10022",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4085",
  "ui-addon-opt": "/ui-addon-opt/static-4.8216",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9977",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24822",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4711",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4022",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5521",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3935",
  "timezone-utils": "/timezone-utils/static-2.5075",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "chatspot-core": "/chatspot-core/static-1.20467",
  "chirp-fetch": "/chirp-fetch/static-1.1713",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2724",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9549",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3653",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3995",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3546",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17976",
  "growth-data-modal": "/growth-data-modal/static-1.5189",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2903",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1380",
  "navigation-components": "/navigation-components/static-1.17379",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4520",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.372",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7358",
  "ui-universal-auth": "/ui-universal-auth/static-1.8744",
  "user-context": "/user-context/static-1.4930",
  "cms-field-types": "/cms-field-types/static-1.4638",
  "content-icons-ui": "/content-icons-ui/static-1.2167",
  "integrations-lib": "/integrations-lib/static-1.15531",
  "calling-global-api": "/calling-global-api/static-1.63791",
  "calling-internal-common": "/calling-internal-common/static-1.31126",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65173",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57467",
  "commerce-products-lib": "/commerce-products-lib/static-1.8946",
  "crm-links": "/crm-links/static-1.6097",
  "file-manager-components": "/file-manager-components/static-1.22992",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.511",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4078",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.463",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48108",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3819",
  "property-value-citations": "/property-value-citations/static-1.1476",
  "pulse": "/pulse/static-1.347",
  "smart-property-lib": "/smart-property-lib/static-1.6058",
  "tiered-pricing": "/tiered-pricing/static-1.873",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8877",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19525",
  "tinymce-themes": "/tinymce-themes/static-1.55806",
  "data-token-picker": "/data-token-picker/static-1.16098",
  "hub-http-contrib": "/hub-http-contrib/static-1.2874",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39921",
  "tinymce-plugins": "/tinymce-plugins/static-1.56950",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5045",
  "magpie-lib": "/magpie-lib/static-1.5425",
  "magpie-types": "/magpie-types/static-1.4885",
  "simple-logging-lib": "/simple-logging-lib/static-1.2881",
  "content-assistance-lib": "/content-assistance-lib/static-1.7494",
  "dashboard-lib": "/dashboard-lib/static-1.80758",
  "ExportDialog": "/ExportDialog/static-6.10218",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17693",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17685",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8524",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8381",
  "feedback-loader": "/feedback-loader/static-1.28926",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4482",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.170",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2188",
  "purchase-motions-api": "/purchase-motions-api/static-1.5524",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1408",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.556",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.539",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17094",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12946",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5419",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7619",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10204",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31132",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10870",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6372",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.341",
  "customer-data-tracking": "/customer-data-tracking/static-1.6713",
  "commerce-permissions": "/commerce-permissions/static-1.590",
  "products-iframe-lib": "/products-iframe-lib/static-1.7417",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9933",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8665",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3985",
  "video-components-external": "/video-components-external/static-1.10668",
  "video-data-lib": "/video-data-lib/static-1.34326",
  "directed-graph": "/directed-graph/static-1.770",
  "event-emitter": "/event-emitter/static-1.778",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5368",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9634",
  "fsm": "/fsm/static-1.3562",
  "policy-lib": "/policy-lib/static-1.6607",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9697",
  "navigation-messaging": "/navigation-messaging/static-1.6706",
  "FileManagerLib": "/FileManagerLib/static-1.38632",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8926",
  "FileManagerCore": "/FileManagerCore/static-1.38491",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12095",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11070",
  "react-codemirror": "/react-codemirror/static-1.10457",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9718",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14092",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8527",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28032",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8398",
  "payment-link-components": "/payment-link-components/static-1.23028",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2830",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35118",
  "sales-views-client-types": "/sales-views-client-types/static-1.4117",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3473",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11570",
  "content-media-compositions": "/content-media-compositions/static-2.15577",
  "media-bridge-lib": "/media-bridge-lib/static-1.18620",
  "trellis-story-utils": "/trellis-story-utils/static-1.4351",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5658",
  "FileManagerImages": "/FileManagerImages/static-1.36143",
  "video-components": "/video-components/static-1.12671",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4362",
  "video-embed": "/video-embed/static-1.35160",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67789",
  "layout-data-lib": "/layout-data-lib/static-1.9395",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6413",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5763",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4917",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3498",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21361",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3674",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21453",
  "outpost": "/outpost/static-1.4033",
  "advanced-menus-core": "/advanced-menus-core/static-1.14863",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11834",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33539",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14862",
  "simple-menus-lib": "/simple-menus-lib/static-1.16379"
}
};
